/* eslint-disable react/prop-types,max-len */
import React from 'react';
import { PieChart, Pie, Cell, Sector } from 'recharts';
import { getShortenedText } from 'utils/misc';
import {
  secondaryText,
  disabledText,
  GRAPH_AND_CHART_COLORS,
} from 'themes/colors';

const renderActiveShape = (props) => {
  const {
    cx, cy, innerRadius, outerRadius, startAngle, endAngle,
    fill, payload, percent,
  } = props;
  const roundedPercent = +((Math.round(percent * 100) / 100) * 100).toFixed(2);
  return (
    <g>
      <text
        x={cx}
        y={cy}
        dy={8}
        textAnchor="middle"
        style={{
          fontSize: '32px',
          fontWeight: 'bold',
          fill: secondaryText,
        }}
      >
        {roundedPercent}%
      </text>
      <text
        x={cx}
        y={cy}
        dy={32}
        textAnchor="middle"
        style={{
          fontSize: '12px',
          fill: disabledText,
        }}
      >
        {getShortenedText(payload.name)}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={innerRadius - 3}
        outerRadius={outerRadius + 3}
        fill={fill}
      />
    </g>
  );
};

const LinePieChart = (props) => {
  const { activeIndex, setActiveIndex, dataSource } = props;
  const onPieEnter = (data, index) => {
    setActiveIndex(index);
  };

  return (
    <PieChart
      width={190}
      height={190}
      margin={{
        top: 0,
        right: 35,
        bottom: 0,
        left: 35,
      }}
    >
      <Pie
        activeIndex={activeIndex}
        activeShape={renderActiveShape}
        data={dataSource}
        innerRadius={76}
        outerRadius={84}
        onMouseEnter={onPieEnter}
      >
        {dataSource.map((entry, index) => <Cell fill={GRAPH_AND_CHART_COLORS[index % GRAPH_AND_CHART_COLORS.length]} />)}
      </Pie>
    </PieChart>
  );
};

export default LinePieChart;
